import { ReactNode } from "react";

interface LegalSectionProps {
  id: string;
  title: string;
  icon: ReactNode;
  lastUpdated: string;
  children: ReactNode;
}

export const LegalSection = ({ id, title, icon, lastUpdated, children }: LegalSectionProps) => {
  return (
    <section id={id} className="scroll-mt-24 mb-16">
      <div className="flex items-center gap-3 mb-4">
        <div className="text-primary">{icon}</div>
        <div className="flex-1">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground">{title}</h2>
          <p className="text-sm text-muted-foreground mt-1">Last updated: {lastUpdated}</p>
        </div>
      </div>
      <div className="prose prose-slate dark:prose-invert max-w-none">
        {children}
      </div>
      <div className="h-px bg-border mt-12" />
    </section>
  );
};
